import { createFileRoute } from '@tanstack/react-router';

import {
  bankAccountMedScreen,
  accountMedSearch,
  loadBankAccountMessages,
  loadBankAccountScreens,
} from '@/modules/bank-account/route';
import { lazyScreen } from '@/shared/screen';

export const Route = createFileRoute('/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/')({
  validateSearch: accountMedSearch,
  staticData: { screen: bankAccountMedScreen },
  loader: loadBankAccountMessages,
  component: lazyScreen(loadBankAccountScreens, 'BankAccountMedScreen'),
});
